<template>
  <v-layout>
    <v-app-bar elevation="0" class="border-b px-4">
      <v-app-bar-nav-icon
        v-if="isNavbarActive"
        variant="text"
        @click.stop="drawer = !drawer"
        class="mx-0"
      ></v-app-bar-nav-icon>
      <v-toolbar-title @click="homepageRedirect">
        <v-img height="48px" width="106px" src="/images/logo.png"
      /></v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="$vuetify.display.mdAndUp">
        <AccountBelajarWajib />
        <v-menu width="254">
          <template v-slot:activator="{ props }">
            <v-btn
              icon="mdi-chevron-down"
              variant="text"
              v-bind="props"
            ></v-btn>
          </template>
          <v-list>
            <v-list-item title="Keluar" @click="logoutBelajarWajib">
              <template v-slot:prepend>
                <v-icon icon="mdi-logout"></v-icon>
              </template>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <v-menu v-else width="254">
        <template v-slot:activator="{ props }">
          <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props"></v-btn>
        </template>
        <v-list>
          <AccountBelajarWajib class="mb-2" />
          <v-divider></v-divider>
          <v-list-item title="Keluar" @click="logoutBelajarWajib">
            <template v-slot:prepend>
              <v-icon icon="mdi-logout"></v-icon>
            </template>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main class="bg-grey-lighten-5">
      <v-container
        fluid
        class="px-8"
        style="min-height: calc(var(--vh, 1vh) * 100)"
      >
        <v-row
          :class="
            isEcosystemPage && ($vuetify.display.xl || $vuetify.display.xxl)
              ? 'w-75 ma-auto'
              : ''
          "
        >
          <BreadcrumsBelajarWajib />
          <NuxtPage />
        </v-row>
      </v-container>
    </v-main>
  </v-layout>
</template>
<script>
import BreadcrumsBelajarWajib from "~/components/pembelajaran_wajib/shared/BreadcrumsBelajarWajib";
import AccountBelajarWajib from "~/components/pembelajaran_wajib/shared/AccountBelajarWajib";

export default {
  components: {
    BreadcrumsBelajarWajib,
    AccountBelajarWajib,
  },
  data: () => ({
    drawer: null,
  }),
  computed: {
    isNavbarActive() {
      return Object.keys(useRoute().params).length > 0;
    },
    navbarLink() {
      const type = localStorage.getItem("courseType");
      const data = [];
      data.push(type);
      const link = [];
      for (let i = 0; i < data.length; i++) {
        const materi = {
          name: `Materi Swajar ${data[i]}`,
          to: `/pembelajaran-wajib/swajar-${data[i]}`,
          icon: "mdi-book-open-page-variant",
        };
        const jurnal = {
          name: `Jurnal  ${data[i]}`,
          to: `/pembelajaran-wajib/swajar-${data[i]}/jurnal`,
          icon: "mdi-notebook",
        };
        const evaluasiSatu = {
          name: "Evaluasi Akademik 1",
          to: `/pembelajaran-wajib/swajar-${data[i]}/evaluasi-akademik-1`,
          icon: "mdi-clipboard-text-clock",
        };
        const evaluasiDua = {
          name: "Evaluasi Akademik 2",
          to: `/pembelajaran-wajib/swajar-${data[i]}/evaluasi-akademik-2`,
          icon: "mdi-clipboard-text",
        };
        const profil = {
          name: "Profil Peserta",
          to: `/pembelajaran-wajib/swajar-${data[i]}/profil`,
          icon: "mdi-account",
        };
        const microlearning = {
          name: "Microlearning",
          to: `/pembelajaran-wajib/swajar-${data[i]}/microlearning`,
          icon: "mdi-book-open-variant",
        };
        const pusatBantuan = {
          name: "Pusat Bantuan",
          to: `/pusat-bantuan`,
          icon: "mdi-face-agent",
        };
        if (type !== "MOT") {
          link.push(materi);
          if (type !== "TOC") {
            link.push(microlearning);
          }
          if (type !== "CPNS") {
            link.push(jurnal);
          }
          link.push(evaluasiSatu, profil, pusatBantuan);
        } else {
          link.push(materi, evaluasiSatu, evaluasiDua, profil, pusatBantuan);
        }
      }
      return link;
    },
    isEcosystemPage() {
      const path = this.$route.path.split("/");
      return path.includes("pembelajaran-ekosistem");
    },
  },
  methods: {
    logoutBelajarWajib() {
      useBelajarWajibStore().clearTokens();
      return navigateTo({ path: "/pembelajaran-wajib/login" });
    },
    homepageRedirect() {
      const path = this.$route.path.split("/");
      return navigateTo(
        path.includes("pembelajaran-ekosistem") ? "/pembelajaran-wajib" : "/"
      );
    },
  },
};
</script>
